module.exports = __webpack_public_path__ + "01f43047/img/revit-icon.5ff0d581.svg";